/* eslint-disable no-useless-escape */
import { getPaths, getTenantId, getTenantDir } from "../plugins/env"
// 默认加上 www 为前缀
const canonicalizeUrl = url => {
  if (url.includes("wellcome.com.hk") && !url.includes("://www.")) {
    return url.replace("://", "://www.")
  }
  return url
}

// 兜底逻辑，解决x-forwarded-host 获取不到正常domain问题， 根据 tenantId 和环境获取正确的域名
const getProductionOrigin = () => {
  const tenantId = getTenantId()
  const nodeEnv = process.env.NODE_ENV

  // 本地开发环境判断
  const isLocalDev = nodeEnv === "development" || nodeEnv === "production-proxy"

  // 本地开发环境：使用当前域名
  if (isLocalDev) {
    if (process.server) {
      // 服务端：使用请求的域名
      const { MAIN_ORIGIN } = getPaths()
      return MAIN_ORIGIN
    } else {
      // 客户端：使用当前页面域名
      return window.location.origin
    }
  }

  // 根据环境确定域名前缀
  let domainPrefix = ""
  if (nodeEnv === "uat") {
    domainPrefix = "https://uatcoldstorage.rta-os.com"
  } else if (nodeEnv === "test") {
    domainPrefix = "https://testcoldstorage.rta-os.com"
  } else {
    return "https://coldstorage.com.sg"
  }

  // UAT 和 test 环境都使用相同的域名，不需要根据 tenantId 区分
  return domainPrefix
}

export const getHeadMeta = item => {
  const fullPath = item.fullPath || ""
  // const { MAIN_ORIGIN } = getPaths()
  // const url = canonicalizeUrl(MAIN_ORIGIN + fullPath)
  const productionOrigin = getProductionOrigin()
  const url = canonicalizeUrl(productionOrigin + fullPath)
  return [{ name: "og:url", content: url }]
}

export const getHeadLink = item => {
  const { VUE_APP_PUBLIC_PATH } = process.env
  const fullPath = item.fullPath || ""
  // const { MAIN_ORIGIN } = getPaths()
  // const url = canonicalizeUrl(MAIN_ORIGIN + fullPath)
  const productionOrigin = getProductionOrigin()
  const url = canonicalizeUrl(productionOrigin + fullPath)
  return [
    {
      rel: "icon",
      href: `${VUE_APP_PUBLIC_PATH}/public/${getTenantDir()}/favicon.ico`
    },
    {
      rel: "canonical",
      href: url
    },
    {
      rel: "alternate",
      hreflang: item.lang,
      href: url
    }
  ]
}

export const insertScript = publicUrl => {
  const script = [
    {
      hid: "chineseAN",
      body: true,
      innerHTML: `
        function getParameterByName(a){
          var hashParams = location.hash? location.hash.split('?')[1]: '';
          var params = location.search? location.search:'?'+hashParams;
          return(a=params.match(new RegExp("[?\x26]"+a+"\x3D([^\x26]*)(\x26?)","i")))?a[1]:a
        }
        var txid = getParameterByName('txId');
        if (txid&&!/[^a-z0-9]/.test(txid)) {
          txid = txid.length>13?txid.substring(0, 13):txid;
          var date = new Date();
          date.setTime(date.getTime()+ 2592000 * 100000);
          var expirationTime = date.toUTCString();
          document.cookie = "txid=" + txid + "; expires=" + expirationTime + "; path=/; domain=." + location.hostname.replace(/^www\./i, "");
        }
      `
    },
    {
      hid: "newrelic",
      src: `${publicUrl}/public/newrelic.js`,
      defer: true,
      type: "text/javascript",
      charset: "utf-8"
    },
    {
      hid: "zeSnippet",
      src: `https://static.zdassets.com/ekr/snippet.js?key=4dae2ed7-2b57-45fd-b73c-3185fed0120d`,
      id: "ze-snippet",
      body: true,
      type: "text/javascript",
      async: true,
      charset: "utf-8"
    },
    {
      hid: "recaptcha",
      src: `https://www.google.com/recaptcha/api.js?render=6Lc2BMMqAAAAAHCb0v1sJNO5lesaGtjruz7d1r1X`,
      id: "recaptcha",
      body: true,
      type: "text/javascript",
      async: true,
      charset: "utf-8"
    }
  ]
  const noScript = []
  return {
    script,
    noScript
  }
}

const FACEBOOK_PIXEL_ID = {
  0: "182701316148340",
  15: "303964103556776",
  10: "1000744010450219"
}
export const generatorScriptByTenantId = () => {
  const { VUE_APP_PUBLIC_PATH } = process.env
  const tenantId = getTenantId()
  const publicUrl = VUE_APP_PUBLIC_PATH
  const script = [
    {
      hid: "facebook",
      body: true,
      innerHTML: `
        !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '${FACEBOOK_PIXEL_ID[tenantId]}');
        fbq('track', 'PageView');
      `
    }
  ]
  const noScript = [
    {
      hid: "noScript",
      body: true,
      innerHTML: `
        <img height="1" width="1" style="display:none"
        src="https://www.facebook.com/tr?id=${FACEBOOK_PIXEL_ID[tenantId]}&ev=PageView&noscript=1"
        />
      `
    }
  ]
  return {
    script,
    noScript
  }
}

export const getStyle = function () {
  const tenantId = getTenantId()
  // tenantId wellcome is 15 , MPJ is 0, coldStorage is 10
  console.log("==== getStyle tenantId ===", tenantId)
  const style = `{
      --brand-50: #F8FAF0;
      --brand-100: #F3F5E6;
      --brand-200: #CFD59A;
      --brand-300: #B6C068;
      --brand-400: #9EAB35;
      --brand-500: #869603;
      --brand-700: #5E6902;
      --primary-50: #F8FAF0;
      --primary-100: #F3F5E6;
      --primary-200: #CFD59A;
      --primary-300: #B6C068;
      --primary-400: #9EAB35;
      --primary-500: #869603;
      --primary-700: #5E6902;
      --secondary-50: #FFFCF4;
      --secondary-100: #FAF4E9;
      --secondary-200: #F8F1E2;
      --secondary-400: #F1DFBE;
      --secondary-500: #EFDBB7;
      --secondary-700: #786E5C;
      --delivery-background: #FFF;
      --progress-define-back: #E5E5E5;
      --progress-success: #46A147;
      --cart-background: #CC2B1E;
      --cart-color: #fff;
      --odrer-byAgainColor-color:#000;
      --delivery-count-color: var(--secondary-500);
      --add-to-cart-color: #fff;
      --add-to-cart-background: var(--primary-500);
    }`
  return [
    {
      cssText: `:root ${style};`,
      type: "text/css"
    }
  ]
}
// 获取:root color
export const getRootStyle = function () {
  const root = document.querySelector(":root")
  const primaryColor = getComputedStyle(root).getPropertyValue("--primary-500")
  const brand500 = getComputedStyle(root).getPropertyValue("--brand-500")
  const progressSuccessColor = getComputedStyle(root).getPropertyValue("--progress-success")
  const primary100 = getComputedStyle(root).getPropertyValue("--primary-100")
  const odrerByAgainColor = getComputedStyle(root).getPropertyValue("--odrer-byAgainColor-color")
  return {
    primaryColor,
    brand500,
    progressSuccessColor,
    primary100,
    odrerByAgainColor
  }
}

export const getCommonHead = () => {
  return {
    style: getStyle(),
    script: generatorScriptByTenantId().script,
    noscript: generatorScriptByTenantId().noScript,
    __dangerouslyDisableSanitizers: ["script", "noscript"]
  }
}
